import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const JO: MarketExceptionType = {
  ...Common,
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  creditCardProvidersSupported: ['VI', 'MC', 'AX'],
  currencyCode: 'JOD',
  defaultEconomyShippingMethod: 'Delivery',
  hasAddressRegion: true,
  hasBankWire: true,
  hasNativeCreditCard: false,
  hasProductAvailability: true,
  isPickupMarket: true,
  rtlLanguages: {
    enabled: true,
    enableGlobalTextAlign: true,
    supportedLanguages: ['ar'],
  },
  showPasswordRequirements: true,
  signUpReCaptcha: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: false,
  },
  skuAvailabilityShippingMethod: 'Delivery',
  supportsStoreCredit: true,
  tax: {
    inclusive: true,
    noFrontendTaxCalculation: true,
    explicitlyExclusive: false,
  },
  hasMepsPay: true,
  omitSubscriptionsAppWide: true, // Subscriptions are not available in Jordan
  addressFormConfig: [
    { field: 'firstName', required: true },
    { field: 'lastName', required: true },
    { field: 'country', required: true },
    { field: 'empty', required: true },
    { field: 'address1', required: true },
    { field: 'address2', required: false },
    { field: 'city', required: true },
    { field: 'state', required: true },
    { field: 'zip', required: false }, // Zip is not required in Jordan
  ],
}
